/**
 *  @class
 *  @function CartNotes
 *
 */
if (!customElements.get('cart-notes')) {
  class CartNotes extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('#order-note-toggle')) {
          this.open();
        } else if (event.target.closest('[data-cart-notes-save], [data-cart-notes-close]')) {
          this.close();
        }
      });
    }
    open() {
      var toggle = this.querySelector('#order-note-toggle');
      var content = toggle.nextElementSibling;
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      content.hidden = isOpen;
      content.classList.toggle('active', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    }
    close() {
      var toggle = this.querySelector('#order-note-toggle');
      var content = toggle.nextElementSibling;
      content.classList.remove('active');
      content.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      this.saveNotes();
    }
    saveNotes() {
      var notes = this.querySelector('#mini-cart__notes');
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          'note': notes.value
        })
      });
    }
  }
  customElements.define('cart-notes', CartNotes);
}